import axios from '../../util/axios-portals';

import * as actionTypes from './actionTypes';

let logoutTimer = null;

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
}

export const authSuccess = (token, role) => {
    return {
        type: actionTypes.AUTH_SUCCESS, 
        token, role
    };
}

export const checkAuthTimeout = (expiresIn) => {
    return dispatch => {
        if(logoutTimer) {
            clearTimeout(logoutTimer);
        }

        logoutTimer = setTimeout(() => {
            dispatch(logout());
        }, expiresIn * 1000);
    };
}

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL, 
        error
    }
}

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');

    return {
        type: actionTypes.AUTH_LOGOUT
    };
}

export const setAuthInformation = (token, expiresIn, role) => {
    return dispatch => {
        const expirationDate = new Date(new Date().getTime() + (expiresIn * 1000));

        localStorage.setItem('token', token);
        localStorage.setItem('expirationDate', expirationDate);
    
        dispatch(authSuccess(token, role));
        dispatch(checkAuthTimeout(expiresIn));
    }
}

export const auth = (username, password) => {
    return dispatch => {
        dispatch(authStart());

        const authData = {
            usr_username: username, 
            usr_password: password
        };

        axios.post('/token', authData)
            .then(response => {
                const { token, expiresIn, role } = response.data;

                dispatch(setAuthInformation(token, expiresIn, role));
            })
            .catch(error => {
                dispatch(authFail(error));
            });
    }
}

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');

        // If no token is available, dispatch the logout function just to be sure everything has been reset
        if(!token) {
            dispatch(logout());
        }
        else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));

            // Is our token still valid?
            if(expirationDate > new Date()) {
                // User was logged in last time they visited our page
                // Attempt to generate a new token using the existing token
                dispatch(authGenerateNewTokenFromExistingToken(token));
            }
            // Last known token is not valid, log us out
            else {
                dispatch(logout());
            }
        }
    }
}

export const authSetRedirectUrl = (url) => {
    return {
        type: actionTypes.AUTH_SET_REDIRECT_URL, 
        url
    };
}

export const authGenerateNewTokenFromExistingToken = (token) => {
    return (dispatch) => {
        dispatch(authStart());

        axios.post('/refresh', {}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
            const { token, expiresIn, role } = response.data;
            
            dispatch(setAuthInformation(token, expiresIn, role));
        })
        .catch(err => dispatch(logout()));
    }
}